import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-email-already-verified',
  templateUrl: './email-already-verified.component.html',
  styleUrls: ['./email-already-verified.component.scss']
})
export class EmailAlreadyVerifiedComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  login(){
    this.router.navigateByUrl('/auth');
  }

}
